<!-- This should have all the header and nav elements-->
<header id="header"></header>

@if (isLoggedIn) {
  <sidebar id="menu"></sidebar>
}

<!-- The routed views render in the <router-outlet>-->
<div id="wrapper" class="root-wrapper">
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>

@if (loading$ | async; as loading) {
  <div
    style="
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 1000000;
      top: 0;
      background-color: rgba(255, 255, 255, 0.4);
    "
  >
    <div style="position: relative; vertical-align: middle; top: 30%">
      <div
        style="
          margin-left: auto;
          margin-right: auto;
          width: 60px;
          z-index: 1000001;
        "
      >
        <img src="assets/images/loading-bars.svg" width="128" height="64" />
      </div>
    </div>
  </div>
}

<router-outlet name="modal"></router-outlet>
